import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterLink, RouterOutlet } from '@angular/router';

import {
  MOBI_UI_HEADER_LOGO,
  MobiUiFooterComponent,
  MobiUiHeaderComponent,
  MobiUiIconComponent,
  MobiUiLanguage,
  MobiUiLanguageService,
} from '@mobi/rwc-ui-components-ng-jslib';

import { Login } from './login/login';

@Component({
  selector: 'app-main-layout',
  templateUrl: './main-layout.html',
  imports: [
    // vendor
    RouterOutlet,
    RouterLink,

    // ui components
    MobiUiFooterComponent,
    MobiUiIconComponent,
    MobiUiHeaderComponent,

    // local
    Login,
  ],
  styleUrls: ['./main-layout.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MainLayout {
  #uiLanguageService = inject(MobiUiLanguageService);

  protected MOBI_UI_HEADER_LOGO: typeof MOBI_UI_HEADER_LOGO =
    MOBI_UI_HEADER_LOGO;

  protected logoClickHandler(): void {
    console.log('Logo was clicked, maybe you want to navigate somewhere?');
  }

  protected handleLanguageChange(language: MobiUiLanguage): void {
    this.#uiLanguageService.setLanguage(language);
  }
}
